import React from 'react';
import ReactDOM from 'react-dom/client';

// Ant Design v5 reset — normalises browser default styles.
// This is the only CSS file you need to import globally.
import 'antd/dist/reset.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
